export interface bl_fi_generic_doc_single_line {
  guid: string;
  namespace: string;
  module_guid: string;
  applet_guid: string;
  server_doc_type: string;
  client_doc_type: string;
  guid_parent: string;
  guid_comp: string;
  guid_branch: string;
  guid_store: string;
  guid_profit_center: string;
  guid_segment: string;
  guid_project: string;
  guid_dimension: string;
  guid_glcode: string;
  label_json: any;
  foreign_ccy: string;
  base_doc_line_guid: string;
  base_doc_line_ccy: boolean;
  base_doc_line_xrate: number;
  doc_ccy: string;
  amount_cogs: number;
  amount_std: number;
  amount_discount: number;
  amount_net: number;
  tax_gst_code: string;
  tax_gst_type: string;
  tax_gst_rate: number;
  amount_tax_gst: number;
  tax_wht_type: string;
  tax_wht_code: string;
  tax_wht_rate: number;
  amount_tax_wht: number;
  amount_txn: number;
  amount_json: any;
  amount_open_balance: number;
  amount_signum: number;
  item_guid: string;
  item_code: string;
  item_machine_code: string;
  item_name: string;
  item_desc: string;
  item_remarks: string;
  item_reference_no: string;
  item_custom_template_json: any;
  item_custom_data_json: any;
  item_property_json: any;
  item_child_json: any;
  item_to_item_link_json: any;
  sort_code: string;
  line_option_json: any;
  txn_type: string;
  txn_code: string;
  reference_no: string;
  quantity_signum: number;
  quantity_base: number;
  unit_price_by_uom: number;
  qty_by_uom: number;
  unit_disc_by_uom: number;
  client_key: string;
  client_source: string;
  client_hashed_value: string;
  uom_json: any;
  line_property_json: any;
  position_id: string;
  date_txn: string;
  log_json: any;
  created_date: string;
  updated_date: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  status: string;
  revision: string;
  vrsn: string;
  acl_config: any;
  acl_policy: any;
  qty_open: number;
  serial_no: any;
  batch_no: any;
  t2t_doc_hdr_guid: string;
  t2t_doc_line_guid: string;
  client_data_source: string;
  client_item_guid: string;
  client_item_code: string;
  entity_line_guid: string;
  point_type: string;
  point_amount: number;
  point_currency: string;
  entity_fi_item_link_guid: string;
  entity_inv_item_link_guid: string;
  t2t_tenant_guid: string;
  coupon_hdr_guid: string;
  coupon_line_guid: string;
  item_txn_type: string;
  item_sub_type: string;
  client_value: string;
  client_doc_status_01: string;
  client_doc_status_02: string;
  client_doc_status_03: string;
  client_doc_status_04: string;
  client_doc_status_05: string;
  guid_store_2: string;
  arap_pns_amount: number;
  arap_stlm_amount: number;
  tracking_id: string;
}

export class bl_fi_generic_doc_single_line {
  guid: string;
  namespace: string;
  module_guid: string;
  applet_guid: string;
  server_doc_type: string;
  client_doc_type: string;
  guid_parent: string;
  guid_comp: string;
  guid_branch: string;
  guid_store: string;
  guid_profit_center: string;
  guid_segment: string;
  guid_project: string;
  guid_dimension: string;
  guid_glcode: string;
  label_json: any;
  foreign_ccy: string;
  base_doc_line_guid: string;
  base_doc_line_ccy: boolean;
  base_doc_line_xrate: number;
  doc_ccy: string;
  amount_cogs: number;
  amount_std: number;
  amount_discount: number;
  amount_net: number;
  tax_gst_code: string;
  tax_gst_type: string;
  tax_gst_rate: number;
  amount_tax_gst: number;
  tax_wht_type: string;
  tax_wht_code: string;
  tax_wht_rate: number;
  amount_tax_wht: number;
  amount_txn: number;
  amount_json: any;
  amount_open_balance: number;
  amount_signum: number;
  item_guid: string;
  item_code: string;
  item_machine_code: string;
  item_name: string;
  item_desc: string;
  item_remarks: string;
  item_reference_no: string;
  item_custom_template_json: any;
  item_custom_data_json: any;
  item_property_json: any;
  item_child_json: any;
  item_to_item_link_json: any;
  sort_code: string;
  line_option_json: any;
  txn_type: string;
  txn_code: string;
  reference_no: string;
  quantity_signum: number;
  quantity_base: number;
  unit_price_by_uom: number;
  qty_by_uom: number;
  unit_disc_by_uom: number;
  client_key: string;
  client_source: string;
  client_hashed_value: string;
  uom_json: any;
  line_property_json: any;
  position_id: string;
  date_txn: string;
  log_json: any;
  created_date: string;
  updated_date: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  status: string;
  revision: string;
  vrsn: string;
  acl_config: any;
  acl_policy: any;
  qty_open: number;
  serial_no: any;
  batch_no: any;
  t2t_doc_hdr_guid: string;
  t2t_doc_line_guid: string;
  client_data_source: string;
  client_item_guid: string;
  client_item_code: string;
  entity_line_guid: string;
  point_type: string;
  point_amount: number;
  point_currency: string;
  entity_fi_item_link_guid: string;
  entity_inv_item_link_guid: string;
  t2t_tenant_guid: string;
  coupon_hdr_guid: string;
  coupon_line_guid: string;
  item_txn_type: string;
  item_sub_type: string;
  client_value: string;
  client_doc_status_01: string;
  client_doc_status_02: string;
  client_doc_status_03: string;
  client_doc_status_04: string;
  client_doc_status_05: string;
  guid_store_2: string;
  arap_pns_amount: number;
  arap_stlm_amount: number;
  tracking_id: string;
}

